import { useFeatureFlagStore } from '@moniebook-web/store';
import { config as appConfig } from './config';
import { logger } from './log';
import { itemService } from './services';
import { useRegisterConfiguration } from './store';
import {
    CHANGE_TRACKER_TIMESTAMPS_KEY,
    getStoredTimestamp,
    type LocalChangeTrackerTimestamps,
    REGISTER_TRACKER_TIMESTAMPS_KEY,
    type RegisterChangeTrackerTimestamps,
    setStoredTimestamp,
} from './timestamps';
import { FEATURE_FLAGS, SALE_LOG_EVENT } from './types';

export async function revalidateStockDetails(ignoreFeatureFlag = false) {
    const { featureFlags } = useFeatureFlagStore.getState();

    const enableMonitoring =
        !!featureFlags?.[FEATURE_FLAGS.ENABLE_STOCK_DIVERGENCE_MONITORING];

    const isFallbackEnabled =
        featureFlags?.[FEATURE_FLAGS.ENABLE_STOCK_TRACKING_FALLBACK] ||
        ignoreFeatureFlag;

    const { config } = useRegisterConfiguration.getState();

    if (!isFallbackEnabled) return;

    try {
        const changeTrackerTimestamps = (await getStoredTimestamp(
            CHANGE_TRACKER_TIMESTAMPS_KEY,
        )) as LocalChangeTrackerTimestamps;

        const registerEventTimestamp = (await getStoredTimestamp(
            REGISTER_TRACKER_TIMESTAMPS_KEY,
        )) as RegisterChangeTrackerTimestamps;

        const lastAdjustment =
            registerEventTimestamp.stockAdjustment ??
            changeTrackerTimestamps.items ??
            '';

        const totalDivergence = await itemService.fetchAndBulkUpdateStock(
            lastAdjustment,
            enableMonitoring,
        );

        if (enableMonitoring) {
            logger.error({
                eventName: SALE_LOG_EVENT,
                message: JSON.stringify({
                    business_id: config.businessId,
                    register_id: config.registerId,
                    branch_id: config.branchId,
                    has_divergence: String(!!totalDivergence.length),
                    stock_divergence: totalDivergence,
                    register_version: appConfig.APP_VERSION,
                }),
            });
        }

        const now = new Date().toISOString();

        await setStoredTimestamp(
            { stockAdjustment: now },
            REGISTER_TRACKER_TIMESTAMPS_KEY,
        );
    } catch {
        // silently ignore; non-critical revalidation
    }
}
